import React, { Component } from "react";
import "./Popup.scss";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class Popup extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
  }
  state = {
    Show: "none"
  };
  dream = dat => {
    console.log("111", dat);
    this.setState({
      Show: "block"
    });
  };
  Hide = () => {
    this.setState({
      Show: "none"
    });
  };
  agree = () => {
    console.log(this.props.punishBalance);
    if (isiOS) {
      try {
        window.webkit.messageHandlers.IOSNativePayBond.postMessage(
          `${this.props.punishBalance}`
        );
        this.setState({
          Show: "none"
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      }
    } else {
      try {
        window.app.payBondDialog(`${this.props.punishBalance}`);
        this.setState({
          Show: "none"
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      }
    }
  };

  render() {
    return (
      <div className="Popup" style={{ display: this.state.Show }}>
        <div className="Popup_home">
          <img
            src={require("../assets/cf_ic_cancel.png")}
            onClick={this.Hide}
          />
          <nav className="Popup_content">
            <h2>邮宝保证金协议</h2>
            <div className="protocol">
              1、协议的确认和接纳 <br />
              1.1
              在您接受本《邮宝邮币卡服务平台保证金协议》（以下简称"协议"）之前，请务必仔细阅读本协议各条款的规定。无论您事实上是否认真阅读了本服务协议，只要您点击了下一步操作，您的行为即表示您签名接受本协议的所有条款，本协议与您亲笔签署的任何书面协议一样有效。
              <br /> 1.2
              本协议内容包括本协议正文及所有已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。您对本协议的接受，视为您已接受与邮宝保证金有关的其他规则或协议。
              <br />
              2、简介和授权
              2.1北京风暴迅达科技有限公司（以下简称“风暴迅达”）为一家于2017年成立的国家高新科技企业，致力于利用移动互联科技对邮币卡行业进行产业升级，建立了邮币卡行业首个行业大数据平台、为邮币卡生态链上下游提供产业服务。
              <br />
              2.2邮宝邮币卡服务平台（以下简称“邮宝”）为风暴迅达自主开发、并拥有全部知识产权的关于邮币卡藏品的行情查询与交易平台。邮宝是中国首款邮币卡现货交易线上综合服务平台。邮宝平台的所有权和运作权归风暴迅达所有。
              <br />
              2.3保证金为邮宝平台用户在违反邮宝保证金有关的规则或协议时，为保障其他用户的权益，作为信用保证而缴纳的钱款。
              <br />
              2.4您应根据以下条款之约定缴存，并授权风暴迅达可根据以下条款及其他公示规则的规定锁定、使用、处置保证金，除您主动注销账户并终止在邮宝所有交易活动情况外，上述授权不可撤销。
              <br />
              3、保证金的缴存 3.1
              <br />
              如您为违反邮宝平台规则的用户，则您必须缴纳邮宝平台公布或要求的保证金金额
              ，方可提前解除处罚限制。
              <br /> 3.2
              只要您事实上缴纳了保证金，您的个人资料及店铺的相关页面将出现“已提交保证金”或类似文案之标识。一旦保证金金额为0元则您的个人资料及店铺相关页面的“已提交保证金”或类似文案之标识将被取消，且邮宝可根据平台保证金规则暂停或终止向您提供全部或部分邮宝消费者保障业务权利。
              <br />
              3.3
              尽管有上述约定，本协议有效期内，邮宝可根据业务变化及实际赔付情况以书面方式（邮宝平台站内消息通知、微信号推送、短信通知、电子邮箱、传真等）通知您调整保证金金额。
              <br /> 3.4
              如发生赔付事件导致您需补缴保证金的，则在补缴保证金前，邮宝可暂停或终止向您提供全部或部分邮宝消费者保障业务权利。
              <br />
              4、保证金的止付锁定
              <br />{" "}
              您授权邮宝，将您根据本协议之约定缴存的保证金款项止付锁定于您的邮宝账户中。
              <br /> 5、保证金的止付解除 <br />
              5.1
              若您是缴纳保证金的用户，您申请解除保证金的止付锁定措施，您须同时满足以下条件：
              <br /> （1）没有正在处理的违约赔付投诉记录；
              <br /> （2）没有正在处理的未完结的赔付记录；
              （3）没有未结束的交易记录；
              <br />
              （4）没有未完结的退款记录。
              <br /> 5.2
              申请解除保证金的止付锁定措施后，邮宝会在30个自然日内审核确认（为保障其他用户权益，若您存在或可能存在未完交易或可能出现纠纷的，审核确认时间可能适当延长），在确认通过后保证金的止付锁定措施将解除。如因您未关注邮宝导致的解除保证金的止付锁定措施失败，到账时间将自动往后延期30个自然日。
              <br /> 6、保证金的管理与使用 <br />
              6.1
              您同意，邮宝可在以下情况发生时就保证金的管理和使用发出指令，处置您的保证金：
              <br /> 6.1.1
              如您在邮宝发布商品、达成交易、履行交易相关义务过程中，违反国家法律、法规、政策、邮宝已公示并生效的规则，或违反您对交易人的承诺，或被交易人申请维权、索赔时，邮宝可根据其独立的判断，使用保证金对交易人进行违约赔付。
              <br />
              6.1.2
              如您违反本协议和/或邮宝任何规则和/或您与邮宝签署的其他协议，给邮宝造成任何损失（包括但不限于诉讼赔偿、行政处罚、诉讼费用、律师费用等）的，或您在售商品经质量检测，由第三方权威检验机构检测证明存在质量瑕疵的，邮宝可根据其独立的判断，从保证金中扣除相当于邮宝损失的金额和相当于检测费用的金额，以补偿邮宝所遭受的损失。
              <br />
              6.1.3
              如您违反邮宝相关规则，且根据规则规定应当向邮宝支付违约金的，您同意邮宝有权划扣保证金中的相应金额至邮宝账户作为处罚金。邮宝将就上述情形所划扣的处罚金设立消费者保障专项资金，专门用于消费者权益保障、补偿或赔付事宜。
              <br /> 6.1.4 其他邮宝可处置您的保证金的情形。
              同时，在上述场景下，邮宝均可关闭您邮宝店铺的全部或部分功能。 6.2
              邮宝如使用保证金进行任何赔付，将以书面方式（包括但不限于微信、邮宝平台、手机短信、电子邮件、传真等）通知您。在向您出具的书面通知中，将说明赔付原因及赔付金额。
              <br /> 6.3
              如您的保证金不足以赔付时，您应自行支付额外的赔付金额。在您保证金不足时，除法律有明文规定外，邮宝没有使用自有资金向买家或者任何第三方支付赔偿金、补偿金或其它任何款项的义务，您仍应对交易人或者其他权利人承担赔付、补偿义务。
              <br /> 6.4
              您对交易人、任何第三方以及邮宝的赔付责任不以您已缴纳的保证金数额为限。除法律有明文规定外，邮宝不对交易人或者任何第三方承担任何赔付、赔偿义务，但可根据本协议的规定将您的保证金用于保障对交易人或其他权利人的利益。
              <br />
              {/* 7、解释权 风暴迅达保留对本协议的条款的最终解释权。
              <br /> */}
              <p> 北京风暴迅达科技有限公司</p>
              <p>2019年12月31日</p>
            </div>
            
            <div className="agree">
              <button onClick={this.agree}>同意协议</button>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
export default Popup;
